<template>
  <div>
    <ItemPage
      title="Editar Conteúdo de Mídia"
      size="sm"
      :actions="actions"
      :menu-actions="menuActions"
    >
      <v-form ref="form">
        <v-text-field
          v-model="mediaContent.name"
          label="Nome"
          outlined
        />

        <v-select
          v-model="mediaContent.type"
          :error-messages="formErrors.type"
          :items="contentType"
          item-text="typeName"
          item-value="value"
          label="Tipo"
          outlined
          @input="formErrors.type = ''"
        />

        <v-textarea
          v-model="mediaContent.description"
          counter
          label="Descrição"
          placeholder="Descreva este conteúdo para os alunos"
          outlined
        />

        <v-text-field
          v-model="mediaContent.duration"
          type="number"
          label="Duração em segundos"
          outlined
        />
      </v-form>

      <v-row
        class="mt-6"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Tags
          </div>
          <div class="text-body-2 text--secondary mt-1">
            As tags serão utilizadas para relacionar conteúdos com características em comum.
          </div>
        </v-col>

        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openAddTagDialog"
          >
            <v-icon left>
              mdi-plus
            </v-icon> Adicionar Tag
          </v-btn>
        </v-col>
      </v-row>

      <v-simple-table
        v-if="mediaContent.tags.length > 0"
      >
        <thead>
          <tr>
            <th>Nome da Tag</th>
            <th class="text-right" />
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(tag, index) in mediaContent.tags"
            :key="tag.id"
          >
            <td> {{ tag.tagname ? tag.tagname : tag.name }}</td>

            <td class="text-right">
              <v-btn
                small
                text
                @click="removeTagFromMedia(tag.id)"
              >
                <v-icon
                  small
                  left
                >
                  mdi-delete
                </v-icon>
                Remover
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-row
        class="mt-10"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Tópicos
          </div>
          <div class="text-body-2 text--secondary mt-1">
            Classifique este conteúdo na hierarquia da Aude adicionando tópicos.
          </div>
        </v-col>

        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openAddUnitDialog"
          >
            <v-icon left>
              mdi-plus
            </v-icon> Adicionar Tópico
          </v-btn>
        </v-col>
      </v-row>

      <v-simple-table v-if="mediaContent.units.length > 0">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Dificuldade</th>
            <th class="text-right" />
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="unit in mediaContent.units"
            :key="unit.id"
          >
            <td> {{ unit.name }} </td>
            <!-- <td> {{ unit.name }} - {{ unit.grade_subject.name }} - {{ unit.grade.name }} - {{ unit.education_stage.name }} - {{ unit.education_system.name }}</td> -->
            <td> {{ getDifficultyName(unit.pivot.difficulty) }} </td>
            <td class="text-right">
              <v-btn
                small
                text
                @click="removeUnitFromMedia(unit.id)"
              >
                <v-icon
                  small
                  left
                >
                  mdi-delete
                </v-icon>
                Remover
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-row
        class="mt-10"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm=""
        >
          <div class="font-weight-bold">
            Fontes de mídia
          </div>
          <div class="text-body-2 text--secondary mt-1">
            Fontes de mídia disponíveis para este conteúdo.
          </div>
        </v-col>

        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openAddSourceDialog"
          >
            <v-icon left>
              mdi-plus
            </v-icon> Adicionar Link
          </v-btn>
        </v-col>
      </v-row>

      <v-simple-table>
        <thead>
          <tr>
            <th>Link</th>
            <th>Provedor</th>
            <th class="text-right" />
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="source in mediaContent.sources"
            :key="source.id"
          >
            <td>{{ source.data }}</td>
            <td>{{ source.provider }}</td>
            <td class="text-right">
              <v-btn
                small
                text
                @click="removeSourceFromMedia(source.id)"
              >
                <v-icon
                  small
                  left
                >
                  mdi-delete
                </v-icon>
                Remover
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </ItemPage>
  </div>
</template>

<script>
import AddUnitDialog from '@/components/contents/questions/AddUnitDialog.vue'
import AddTagDialog from '@/components/contents/questions/AddTagDialog.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'
import { getTextForDisplay as getDifficultyName } from '@/enums/questionDifficultyType'
import AddSourceDialog from '@/components/contents/AddSourceDialog.vue'
import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    ItemPage
  },
  mixins: [
    handlesServerValidation
  ],
  data () {
    return {
      mediaContentUpdate: false,
      mediaContentDelete: false,
      name: '',
      loadingSave: false,
      thumbnail: [],
      mediaContent: null
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },

    actions () {
      return [
        {
          label: 'Salvar',
          action: this.updateMediaContent,
          icon: 'mdi-floppy',
          disabled: !this.mediaContentUpdate
        }
      ]
    },

    menuActions () {
      return [
        {
          label: 'Apagar',
          action: this.deleteMediaContent,
          icon: 'mdi-delete',
          disabled: !this.mediaContentDelete
        }
      ]
    }
  },

  created () {
    this.mediaContentUpdate = utils.checkAnyOrOwn('media-contents.update-any')
    this.mediaContentDelete = utils.checkAnyOrOwn('media-contents.delete')
    this.getMediaContent()
  },
  methods: {

    async getMediaContent () {
      this.types()
      this.loading = true
      this.loadingMsg = 'Carregando conteudo...'
      try {
        this.mediaContent = await this.$api.getMediaContent(this.id)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter midia, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
      this.loading = false
    },

    async updateMediaContent () {
      const data = {
        name: this.mediaContent.name,
        type: this.mediaContent.type,
        duration: this.mediaContent.duration,
        description: this.mediaContent.description
      }
      try {
        await this.$api.updateMediaContent(this.id, data)
        this.$store.dispatch('setSnackBar', { text: 'Atualizado com sucesso.' })
        await this.getMediaContent()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },

    async deleteMediaContent () {
      this.$dialog.confirm('Apagar midia?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.deleteMediaContent(this.id)
            this.$store.dispatch('setSnackBar', { text: 'Midia excluida com sucesso.' })
            this.$router.back()
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
            this.getErrors(e)
          }
        })
        .show()
    },

    openAddSourceDialog () {
      this.$dialog.custom(AddSourceDialog).with({ mediaId: this.id }).show()
        .then(async () => {
          await this.getMediaContent()
        })
    },
    async removeSourceFromMedia (sourceId) {
      this.$dialog.confirm('Apagar Fonte de mídia?')
        .text('Tem certeza que deseja remover esta fonte da mídia? Essa ação não pode ser desfeita.')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.removeSourceFromMedia(this.id, sourceId)
            await this.getMediaContent()
            this.$store.dispatch('setSnackBar', { text: 'Fonte removida com sucesso.' })
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível remover a fonte, tente novamente mais tarde.', color: 'red' })
            this.getErrors(e)
          }
        })
        .show()
    },

    openAddUnitDialog () {
      this.$dialog.custom(AddUnitDialog).show()
        .then(async (unit) => {
          if (!unit) {
            return
          }
          await this.addUnitToMedia(unit)
        })
    },
    async addUnitToMedia (unitId) {
      try {
        await this.$api.addUnitToMedia(this.id, unitId)
        await this.getMediaContent()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível adicionar o tópico, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },
    async removeUnitFromMedia (unitId) {
      this.$dialog.confirm('Apagar Tópico?')
        .text('Tem certeza que deseja remover este tópico da mídia? Essa ação não pode ser desfeita.')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.removeUnitFromMedia(this.id, unitId)
            await this.getMediaContent()
            this.$store.dispatch('setSnackBar', { text: 'Tópico removido com sucesso.' })
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível remover o tópico, tente novamente mais tarde.', color: 'red' })
            this.getErrors(e)
          }
        })
        .show()
    },

    openAddTagDialog () {
      this.$dialog.custom(AddTagDialog).show()
        .then(async (tag) => {
          if (!tag) {
            return
          }
          await this.addTagToMedia(tag)
        })
    },
    async addTagToMedia (tagId) {
      try {
        await this.$api.addTagToMedia(this.id, tagId)
        await this.getMediaContent()
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível adicionar a tag, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },
    async removeTagFromMedia (tagId) {
      this.$dialog.confirm('Apagar Tag?')
        .text('Tem certeza que deseja remover esta tag da mídia? Essa ação não pode ser desfeita.')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.removeTagFromMedia(this.id, tagId)
            await this.getMediaContent()
            this.$store.dispatch('setSnackBar', { text: 'Tag removida com sucesso.' })
          } catch (e) {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível remover a tag, tente novamente mais tarde.', color: 'red' })
            this.getErrors(e)
          }
        })
        .show()
    },

    types () {
      this.contentType = utils.contentType()
    },

    // addSourceDialog () {
    //   this.renderComponent += 1
    //   this.dialogAddSource = true
    // },

    // async deleteSource (id) {
    //   await this.$api.deleteSource(id)
    //   this.fetchAll()
    // },

    getDifficultyName
  }
}
</script>
